import { Injectable, isDevMode } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';
import { environment } from '../../../environments/environment';

 // models
import { ServiceFeatures } from '../models/serviceFeatures';

// services
import { SessionService } from './session.service';

@Injectable({
	providedIn: 'root'
})
export class DataDogService {

	constructor(private sessionService: SessionService) {}

	init(): void {
		if (isDevMode()) return;
		if (SessionService.isStaff(this.sessionService.username)) return;
        if (!this.sessionService.defaults.usageTrackingEnabled) return;

		datadogRum.init({
			applicationId: environment.dataDog.appId,
			clientToken: environment.dataDog.clientToken,
			site: 'datadoghq.eu',
			service: 'planohero.datawiz.io',
			env: 'prod',
			// Specify a version number to identify the deployed version of your application in Datadog
			// version: '1.0.0',
			sessionSampleRate: 100,
			sessionReplaySampleRate: this.sessionService.hasFeature(ServiceFeatures.Demo) ? 50 : 20,
			trackUserInteractions: true,
			trackResources: true,
			trackLongTasks: true,
			defaultPrivacyLevel: 'allow'
		});

		datadogRum.setUser({
			id: String(this.sessionService.defaults.user_id),
			name: this.sessionService.username,
			email: this.sessionService.defaults.email
		});
		datadogRum.setUserProperty('client_id', this.sessionService.clientId);
		datadogRum.setUserProperty('tariff_plan', this.sessionService.defaults.tariff_plan.name);
		datadogRum.startSessionReplayRecording();
	}
}